import { useEffect, useRef, useState } from 'react';
import { IoFilter } from 'react-icons/io5';
import { FaSortAmountDownAlt, FaSortAmountUp } from 'react-icons/fa';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Container, Dropdown, Trigger } from './styles';

const orderOptions = [
  { key: '0', label: 'Relevância' },
  { key: '1', label: 'Preço' },
  { key: '2', label: 'Mais antigos' },
  { key: '3', label: 'Mais recentes' },
  { key: '4', label: 'Atualizados recentemente' },
  { key: '5', label: 'Área' },
] as const;

export function OrderByButton() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dropdownRef = useRef<HTMLDivElement>(null);

  const orderParam = searchParams.get('order_by') ?? '0';
  const orderTypeParam = searchParams.get('order_type') ?? 'desc';

  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(
    () => orderOptions.find((opt) => opt.key === orderParam) || orderOptions[0],
  );
  const [orderDirection, setOrderDirection] = useState<'asc' | 'desc'>(
    orderTypeParam === 'asc' ? 'asc' : 'desc',
  );

  const disableOrder =
    selected.key === '0' ||
    selected.key === '2' ||
    selected.key === '3' ||
    selected.key === '4';

  useEffect(() => {
    const currentOrder = searchParams.get('order_by') ?? '0';
    const nextOption =
      orderOptions.find((opt) => opt.key === currentOrder) || orderOptions[0];
    setSelected(nextOption);

    const currentType = searchParams.get('order_type') ?? 'desc';
    if (currentType === 'asc' || currentType === 'desc') {
      setOrderDirection(currentType);
    }
  }, [searchParams]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        event.target instanceof Node &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleApply = () => {
    const next = new URLSearchParams(searchParams);
    next.set('order_by', selected.key);
    next.set('order_type', orderDirection);
    setIsOpen(false);
    navigate(`/resultado-pesquisa?${next.toString()}`);
  };

  return (
    <Container ref={dropdownRef}>
      <Trigger type="button" onClick={() => setIsOpen((prev) => !prev)}>
        <span>{selected.label}</span>
        <IoFilter />
      </Trigger>

      <Dropdown $open={isOpen}>
        <div className="dropdown-header">
          <h2>Ordenar por</h2>
          {!disableOrder && (
            <button
              type="button"
              className="direction-btn"
              title={orderDirection === 'asc' ? 'Crescente' : 'Decrescente'}
              onClick={() =>
                setOrderDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'))
              }
            >
              {orderDirection === 'asc' ? (
                <FaSortAmountDownAlt />
              ) : (
                <FaSortAmountUp />
              )}
            </button>
          )}
        </div>

        <ul>
          {orderOptions.map((option) => (
            <li key={option.key}>
              <button
                type="button"
                className={selected.key === option.key ? 'active' : ''}
                onClick={() => setSelected(option)}
              >
                {option.label}
              </button>
            </li>
          ))}
        </ul>

        <div className="dropdown-footer">
          <button type="button" className="apply-btn" onClick={handleApply}>
            Aplicar
          </button>
        </div>
      </Dropdown>
    </Container>
  );
}
